// ROOT: frontend/src/components/Footer.jsx

import React, { useEffect, useState } from 'react';
import { Instagram, Music2, Twitter, Youtube, Facebook } from 'lucide-react';
import { Link } from 'react-router-dom';
import { api } from '../api';

const Footer = () => {
  const [brandName, setBrandName] = useState('IGGrowth');
  const [contactEmail, setContactEmail] = useState('');
  const [instagramUrl, setInstagramUrl] = useState('');

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const settings = await api.getPublicSettings();

        setBrandName(
          settings?.brandName ||
          settings?.brand_name ||
          'IGGrowth'
        );

        setContactEmail(
          settings?.contactEmail ||
          settings?.contact_email ||
          ''
        );

        setInstagramUrl(
          settings?.instagramUrl ||
          settings?.instagram_url ||
          ''
        );
      } catch (error) {
        console.error('Failed to load footer settings:', error);
      }
    };

    loadSettings();
  }, []);

  return (
    <footer className="border-t border-slate-100 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14">

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">

          <div>
            <Link
              to="/"
              className="inline-flex items-center gap-2 group"
            >
              <div className="relative w-8 h-8">
                <div className="absolute inset-0 rounded-full plixy-gradient-ring" />
                <div className="absolute inset-[3px] rounded-full bg-white" />
                <div className="absolute inset-[7px] rounded-full plixy-gradient-ring opacity-90" />
              </div>

              <span className="text-2xl font-extrabold tracking-tight text-[#0a1930]">
                {brandName}
              </span>
            </Link>

            <p className="mt-5 text-sm leading-6 text-slate-500 max-w-sm">
              AI-powered organic growth for Instagram and TikTok.
              Grow your audience with targeted, authentic engagement.
            </p>

            <div className="mt-6 flex items-center gap-3">
              {instagramUrl && (
                <a
                  href={instagramUrl}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                  className="w-9 h-9 rounded-full border border-slate-200 flex items-center justify-center text-slate-600 hover:text-[#0a1930] hover:bg-slate-50 transition-colors"
                >
                  <Instagram className="w-4 h-4" />
                </a>
              )}

              <a
                href="#tiktok"
                aria-label="TikTok"
                className="w-9 h-9 rounded-full border border-slate-200 flex items-center justify-center text-slate-600 hover:text-[#0a1930] hover:bg-slate-50 transition-colors"
              >
                <Music2 className="w-4 h-4" />
              </a>

              <a
                href="#"
                aria-label="Twitter"
                className="w-9 h-9 rounded-full border border-slate-200 flex items-center justify-center text-slate-600 hover:text-[#0a1930] hover:bg-slate-50 transition-colors"
              >
                <Twitter className="w-4 h-4" />
              </a>

              <a
                href="#"
                aria-label="YouTube"
                className="w-9 h-9 rounded-full border border-slate-200 flex items-center justify-center text-slate-600 hover:text-[#0a1930] hover:bg-slate-50 transition-colors"
              >
                <Youtube className="w-4 h-4" />
              </a>

              <a
                href="#"
                aria-label="Facebook"
                className="w-9 h-9 rounded-full border border-slate-200 flex items-center justify-center text-slate-600 hover:text-[#0a1930] hover:bg-slate-50 transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-[#0a1930]">
              Products
            </h3>

            <div className="mt-5 flex flex-col gap-3">
              <a
                href="#pricing"
                className="text-sm text-slate-500 hover:text-[#0a1930]"
              >
                Instagram Growth
              </a>

              <a
                href="#tiktok"
                className="text-sm text-slate-500 hover:text-[#0a1930]"
              >
                TikTok Growth
              </a>

              <a
                href="#tools"
                className="text-sm text-slate-500 hover:text-[#0a1930]"
              >
                Growth Tools
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-[#0a1930]">
              Company
            </h3>

            <div className="mt-5 flex flex-col gap-3">
              <a
                href="#about"
                className="text-sm text-slate-500 hover:text-[#0a1930]"
              >
                About
              </a>

              <a
                href="#resources"
                className="text-sm text-slate-500 hover:text-[#0a1930]"
              >
                Resources
              </a>

              <a
                href="#products"
                className="text-sm text-slate-500 hover:text-[#0a1930]"
              >
                FAQ
              </a>

              <Link
                to="/get-started"
                className="text-sm text-slate-500 hover:text-[#0a1930]"
              >
                Get Started
              </Link>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-[#0a1930]">
              Contact
            </h3>

            <div className="mt-5">
              {contactEmail ? (
                <a
                  href={`mailto:${contactEmail}`}
                  className="text-sm text-slate-500 hover:text-[#0a1930] break-all"
                >
                  {contactEmail}
                </a>
              ) : (
                <p className="text-sm text-slate-500">
                  Contact details available soon.
                </p>
              )}
            </div>
          </div>

        </div>

        <div className="mt-12 pt-7 border-t border-slate-100 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} {brandName}. All rights reserved.
          </p>

          <div className="flex items-center gap-5 text-xs text-slate-400">
            <a href="#" className="hover:text-slate-600">
              Privacy Policy
            </a>

            <a href="#" className="hover:text-slate-600">
              Terms of Service
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
